import {memo} from 'react';

import GooglePayButtonLib from '@google-pay/button-react';
import styled from 'styled-components';

import {media} from '~/shared/theme/media';

type GooglePayButtonProps = {
  paymentRequest: google.payments.api.PaymentDataRequest;
  onLoadPaymentData: (paymentData: google.payments.api.PaymentData) => void;
  onClick?: () => void;
};

const PayButtonContainer = styled.div`
  width: calc(100% - 32px);
  margin: 0 auto;
  ${media.minLargeMobile`
    margin: 0;
    width: 100%;
  `}
`;

const GooglePayButton = ({paymentRequest, onLoadPaymentData, onClick}: GooglePayButtonProps) => (
  <PayButtonContainer>
    <GooglePayButtonLib
      environment="PRODUCTION"
      paymentRequest={paymentRequest}
      onLoadPaymentData={onLoadPaymentData}
      buttonType="pay"
      buttonColor="default"
      buttonSizeMode="fill"
      buttonRadius={20}
      style={{height: 40, width: '100%'}}
      onClick={onClick}
    />
  </PayButtonContainer>
);

export default memo(GooglePayButton);
